<script>
import {DateTime, Info} from "luxon";

export default {
  install(Vue) {
    var DatetimeUtil = function () {
      var isSameDate = function (first, second) {
        return first && second
            && first.year == second.year
            && first.month == second.month
            && first.day == second.day;
        // NOTE: The Luxon diff function is insanely slow to use.
        // if (!first || !second) {
        //   return false;
        // }
        // var diff = first.diff(second, ["years", "months", "days"]);
        // return diff.years == 0 && diff.months == 0 && diff.days == 0;
      };
      var isOnOrBeforeDate = function (before, date) {
        return before && date
            && ((before.year == date.year && before.month == date.month && before.day <= date.day)
                || (before.year == date.year && before.month < date.month)
                || before.year < date.year);
      };
      var isBeforeDate = function (before, date) {
        return before && date
            && ((before.year == date.year && before.month == date.month && before.day < date.day)
                || (before.year == date.year && before.month < date.month)
                || before.year < date.year);
        // NOTE: The Luxon diff function is insanely slow to use.
        // if (!before || !date) {
        //   return false;
        // }
        // var diff = before.diff(date, ["years", "months", "days"]);
        // return diff.years < 0 || diff.months < 0 || diff.days < 0;
      };
      var isOnOrAfterDate = function (after, date) {
        return after && date
            && ((after.year == date.year && after.month == date.month && after.day >= date.day)
                || (after.year == date.year && after.month > date.month)
                || after.year > date.year);
      };
      var isAfterDate = function (after, date) {
        return after && date
            && ((after.year == date.year && after.month == date.month && after.day > date.day)
                || (after.year == date.year && after.month > date.month)
                || after.year > date.year);
        // NOTE: The Luxon diff function is insanely slow to use.
        // if (!after || !date) {
        //   return false;
        // }
        // var diff = after.diff(date, ["years", "months", "days"]);
        // return diff.years > 0 || diff.months > 0 || diff.days > 0;
      };
      var compareDates = function (a, b) {
        if (isBeforeDate(a, b)) {
          return -1;
        } else if (isAfterDate(a, b)) {
          return 1;
        }
        return 0;
      };
      var getWeekday = function (year, month, day, firstWeekday) {
        var weekday = DateTime.local(year, month, day).weekday;
        if (weekday < firstWeekday) {
          return 7 - (firstWeekday - weekday - 1);
        } else {
          return weekday - (firstWeekday - 1);
        }
      };
      var getWeekNumber = function (year, month, day, firstWeekday) {
        var get = function (year, month, date) {
          // Based on https://en.wikipedia.org/wiki/ISO_week_date calculations.
          var currentDate = DateTime.local(year, month, date);
          var firstDate = DateTime.local(year, 1, 1);
          var dayOfYear = Math.floor((currentDate - firstDate) / (24 * 60 * 60 * 1000)) + 1;
          // If 0 it means the week belong to last year.
          return Math.floor((10 + dayOfYear - getWeekday(year, month, date, firstWeekday)) / 7);
        }
        var number = get(year, month, day);
        if (number == 0) {
          var prev = DateTime.local(year, 12, 31).plus({years: -1});
          number = get(prev.year, prev.month, prev.day);
        } else if (month == 12 && day > 25 && number == get(year, 12, 31)) {
          var weekday = getWeekday(year, 12, 31, firstWeekday);
          // If the last weekday of the year is one of the first 3 weekdays in a week that means that most of that week
          // is in the next year and that means the week is counted as first week next year.
          if (weekday <= 3) {
            number = 1;
          }
        }
        return number;
      };
      var cap = function (str) {
        return str.substring(0, 1).toUpperCase() + str.substring(1);
      }
      var parseOptions = function (options) {
        if (!options) {
          options = {};
        }
        if (typeof options.locale == "undefined") {
          options.locale = "en";
        }
        if (typeof options.firstWeekday == "undefined") {
          options.firstWeekday = 1;
        }
        var names = Info.months("long", {
          locale: options.locale
        });
        var abbreviations = Info.months("short", {
          locale: options.locale
        });
        var len = names.length;
        options.months = [];
        for (var i = 0; i < len; i++) {
          options.months.push({
            name: cap(names[i]),
            abbreviation: cap(abbreviations[i])
          })
        }
        return options;
      }
      var getAsString = function (date, format, options) {
        options = parseOptions(options);
        try {
          if (date) {
            var str = date.toFormat(format, options);
            if (str && str.length) {
              str = str.substring(0, 1).toUpperCase() + str.substring(1);
            }
            return str;
          }
        } catch (err) {
          console.log(err);
        }
        return null;
      };
      var getAsDate = function (str, format, options) {
        options = parseOptions(options);
        try {
          if (str) {
            return DateTime.fromFormat(str, format, options);
          }
        } catch (err) {
          console.log(err);
        }
        return null;
      };
      return {
        isSameDate: isSameDate,
        isOnOrBeforeDate: isOnOrBeforeDate,
        isBeforeDate: isBeforeDate,
        isOnOrAfterDate: isOnOrAfterDate,
        isAfterDate: isAfterDate,
        compareDates: compareDates,
        getWeekday: getWeekday,
        getWeekNumber: getWeekNumber,
        getAsString: getAsString,
        getAsDate: getAsDate
      };
    };
    Vue.$datetimeUtil = new DatetimeUtil()
  }
}
</script>